module.exports = __webpack_public_path__ + "abranch_1.png?163d2cb36643403a864841202e610d3c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/abranch_1.png
// module id = 77
// module chunks = 0